export default __webpack_public_path__ + "static/media/O-091.e24fc5d7.png";